<template>
  <div class="main-content ">
    <div class="payment-page checkout-detail-page">
      <div class="container">
        <Step />
        <MemberInfoBar />

        <PaymentMethod
          title="付款方式"
          v-if="!isNewOrder"
          :payment="payWay"
          @input="setPayway"
        />

        <AmountBoard
          title="應收金額"
          :enableInput="false"
          :collectMoneyAgain="!isNewOrder"
          :receivableAmount="receivableAmount"
          :amount="paidAmount"
          :unpaidAmount="unpaidAmount"
          @input="setAmount"
        >
          <div class="col-12 collect-info">
            <p>日期: {{ date }} 處理人員:{{ account }} {{ name }}</p>
          </div>
        </AmountBoard>

        <button v-if="isNewOrder" class="custom-btn" @click="confirmPayment">
          確認收款
        </button>
        <button v-else class="custom-btn" @click="payAll">
          再次收款
        </button>
      </div>
    </div>
    <CollectMoney @handlePay="receiveComplete" :amount="payAmount" />
    <ReceiveComplete :orderId="orderId" />
    <UnCollectMoney :unpaidAmount="unpaidAmount" @handlePay="receiveComplete" />
    <OrderCompleteNoInvoice :unpaidAmount="unpaidAmount" />
  </div>
</template>

<script>
import Step from '@/components/Layouts/Step';
import CollectMoney from '@/components/Modal/CollectMoney';
import UnCollectMoney from '@/components/Modal/UnCollectMoney';
import ReceiveComplete from '@/components/Modal/ReceiveComplete';
import OrderCompleteNoInvoice from '@/components/Modal/OrderCompleteNoInvoice';
import { isMobile } from 'mobile-device-detect';
import MemberInfoBar from '@/components/MemberInfoBar';
import { getOrderPayment, receiveOrderPayment } from '@/api/order';
import { get } from 'lodash';
import AmountBoard from '@/components/CheckoutDetail/AmountBoard';
import PaymentMethod from '@/components/CheckoutDetail/PaymentMethod';
import PaymentMixin from '@/mixins/payment';
import { createOrder } from '@/api/order';
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  mixins: [PaymentMixin],
  components: {
    Step,
    CollectMoney,
    UnCollectMoney,
    ReceiveComplete,
    OrderCompleteNoInvoice,
    AmountBoard,
    PaymentMethod,
    MemberInfoBar
  },
  data() {
    return {
      isMobile: isMobile,
      orderFromApi: null, //pay order again,
      date: moment().format('yyyy-MM-DD')
    };
  },
  computed: {
    ...mapGetters('order', ['order']), //create order
    ...mapGetters('user', ['account', 'name']),
    orderData() {
      return this.isNewOrder && this.order !== null
        ? this.order
        : this.orderFromApi;
    },
    //訂單建立的導頁
    isNewOrder() {
      return this.$route.query.order_id === undefined;
    },
    orderId() {
      return this.$route.query.order_id ?? get(this.orderFromApi, 'id');
    },
    receivableAmount() {
      return get(this.orderData, 'receivable_amount', 0);
    },
    unpaidAmount() {
      return this.receivableAmount - this.paidAmount;
    },
    paidAmount() {
      return get(this.orderData, 'paid_amount', this.firstPayAmt) ?? 0;
    },
    payAmount() {
      //付款的金額： 建立新訂單時是付輸入的金額, 付尾款時是付剩餘未付款的金額
      return this.isNewOrder ? this.firstPayAmt : this.unpaidAmount;
    },
    //建立訂單步驟時設定的第一次預付款
    firstPayAmt() {
      return get(this.orderData, 'payments[0].amount');
    },
    //付尾款用的付款資訊
    payments() {
      return [
        {
          amount: this.payAmount, //unpaidAmount
          payment_method: this.payWay
        }
      ];
    },
    //付尾款用的post資料
    postData() {
      return {
        order_id: this.orderId,
        payments: this.payments
      };
    }
  },
  watch: {
    orderId: {
      immediate: true,
      handler(val) {
        if (val && this.isNewOrder === false) {
          getOrderPayment(val, data => {
            this.orderFromApi = data;
          });
        }
      }
    }
  },
  created() {
    if (this.isMobile) {
      alert('現在是手機開啟');
      this.$router.push({ name: '歷史購買紀錄' });
    }
  },
  methods: {
    ...mapActions('order', ['clearOrder']),
    receiveComplete() {
      this.isNewOrder ? this.createOrder() : this.payOff();
    },
    confirmPayment() {
      this.$bvModal.show('collect-money');
    },
    payAll() {
      this.$bvModal.show('uncollect-money');
    },
    //建立新訂單
    createOrder() {
      createOrder(this.orderData, data => {
        this.orderFromApi = data;
        this.clearOrder();
        if (data.unpaid_amount !== 0) {
          this.$bvModal.show(`order-complete-no-invoice`);
        } else {
          this.$bvModal.show(`receive-complete`);
        }
      });
    },
    //付款訂單尾款
    payOff() {
      receiveOrderPayment(this.postData, () => {
        this.$bvModal.hide(`collect-money`);
        this.$bvModal.show(`receive-complete`);
      });
    }
  }
};
</script>
